import { getNodeComponentAttributeValue } from "../Definitions/LayoutNode";
import { ScreenSize } from "../Definitions/ScreenSize";
import { SiteStyling } from "../Definitions/SiteStyling";
import { BreakPoints } from "./BreakPoints";


export const FontBreakPoints = {


  Tablet: BreakPoints.Tablet,
  Mobile: BreakPoints.Mobile,
}

export const MinFontSize = 12;

export const getFontSizeFromWidthAndStyle = (viewWidth:number,siteStyling:SiteStyling,forceScreenSize:number = -1):string=>{

  if(!siteStyling.useFontScaling){
    let newSize  =0;

    if(forceScreenSize == ScreenSize.Desktop){
      newSize = siteStyling.desktopFontSize;
    }
    else if(forceScreenSize == ScreenSize.Tablet){
      newSize = siteStyling.tabletFontSize;
    }
    else if(forceScreenSize == ScreenSize.Mobile){
      newSize = siteStyling.mobileFontSize;
    }
    else if(viewWidth < FontBreakPoints.Mobile){
      newSize = siteStyling.mobileFontSize;
    }
    else if(viewWidth < FontBreakPoints.Tablet){
      newSize = siteStyling.tabletFontSize;
    }
    else{
      newSize = siteStyling.desktopFontSize;
    }


    return newSize + "px";

  }

    let maxWidth = 0;// parseInt(pageWidthStr);
    let fontSize = siteStyling.desktopFontSize;

    let realSizes = GetAdjustedFontSizeFromSiteStyling(siteStyling);
  if(forceScreenSize == ScreenSize.Desktop){
    viewWidth = Math.max(viewWidth,FontBreakPoints.Tablet+1);
  }
  else if(forceScreenSize == ScreenSize.Tablet){
    viewWidth = Math.max(viewWidth,FontBreakPoints.Mobile+1);
  }
  else if(forceScreenSize == ScreenSize.Mobile){
    viewWidth = Math.max(viewWidth,0);
  }

    if(viewWidth <= FontBreakPoints.Mobile){
        fontSize = realSizes.mobile; // sicne average mobile is 400ish and the breakpoint is 767 cut it in half for reasonable user input in scaling menu
        maxWidth = FontBreakPoints.Mobile;
    }
    else if(viewWidth <= FontBreakPoints.Tablet){
        fontSize =realSizes.tablet; // sicne average mobile is 400ish and the breakpoint is 767 cut it in half for reasonable user input in scaling menu
        maxWidth = FontBreakPoints.Tablet;
    }
    else{
      let pageWidthStr = getNodeComponentAttributeValue(siteStyling.pageWidth,"pageWidth","1200px").replace("px","");
       maxWidth = parseInt(pageWidthStr);

    }



  return getScaledFontSizeFromWidth(viewWidth,fontSize,maxWidth);

}

export function GetAdjustedFontSizeFromSiteStyling(siteStyling:SiteStyling){

  return {
    desktop: siteStyling.desktopFontSize,
    tablet: siteStyling.tabletFontSize *(1000/780),
    mobile: siteStyling.mobileFontSize * (768/375),
  }


}

export const getScaledFontSizeFromWidth = (viewWidth:number,fontSize:number,maxViewWidth:number ):string=>{


  let percentOfView = (viewWidth) / maxViewWidth;
   let size = fontSize *percentOfView;
  if(size>fontSize)
     size = fontSize;

  if(size< MinFontSize)
      size = MinFontSize;


   return size + "px";



}



export const GetFontScaleCSSLine = (
  fontSize: number = 18,
  maxViewWidth: number = 1200
): string => {

  let maxMax = 32;


  return  `clamp(${MinFontSize}px, calc((100vw / ${maxViewWidth}) * ${fontSize}), ${Math.min(fontSize,maxMax)}px);`;
};
